/* eslint-disable prefer-promise-reject-errors */
import upload from '@/api/upload'
import gdrive from '@/libs/gdrive'

export default {
  file: function (url) {
    return new Promise((resolve, reject) => {
      if (gdrive.isSupportedURL(url)) {
        return this.googleDriveFile(url, resolve, reject)
      }
      upload.header(url).then((response) => {
        resolve(response.data.result.header)
      }, (response) => {
        reject()
      })
    })
  },
  logFile: function (url, key) {
    return upload.fileV3(url, key)
  },
  logImage: function (url, key) {
    return upload.imageV3(url, key)
  },
  googleDriveFile: function (url, resolve, reject) {
    gdrive.get(url).then((file) => {
      resolve({
        url,
        fileName: file.name,
        contentType: file.mimeType,
        contentLength: file.size || 'Google'
      })
    }, () => {
      reject()
    })
  }
}
